import { render, staticRenderFns } from "./ServiceTimeInput.vue?vue&type=template&id=60b023a6&"
import script from "./ServiceTimeInput.vue?vue&type=script&lang=js&"
export * from "./ServiceTimeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports